export default __webpack_public_path__ + "static/part1_4-69211b29e0256e17c0d778493c693d79.png";